import { Dialog, DialogContent, DialogActions, Button, Tabs, Tab, Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { loadCablePdfFromServer } from '../../FileResources/CableFotoPdf/ServiceUtilitiesCableFotoPdf';
import GetAppIcon from '@mui/icons-material/GetApp';

const DialogCablePdf = ({open, onClose, id}) => {
 
  const [uploadMessage, setUploadMessage] = useState('');
  const [serverPdfUrls, setServerPdfUrls] = useState([]); 
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [imagePreviews, setImagePreviews] = useState({});

const loadImagePreview = async (file) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return;

    const response = await fetch(file.url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!response.ok) return;

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);

    setImagePreviews(prev => ({ ...prev, [file.url]: objectUrl }));
  } catch (err) {
    console.error(err);
  }
};

  // Открытие модального окна для PDF
 const handlePdfClick = async (url, fileType) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("Токен не найден");
      return;
    }

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`  // <- важно!
      }
    });

    if (!response.ok) {
      throw new Error("Ошибка загрузки файла");
    }

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);

    setSelectedPdf(objectUrl);
    setSelectedFileType(fileType.includes("image") ? "image" : "pdf");
  } catch (error) {
    console.error("Ошибка открытия файла:", error);
  }
};
  // const handlePdfClick = (url, fileType) => {
  //   setSelectedPdf(url);
  //   setSelectedFileType(fileType.includes("image") ? "image" : "pdf");
  // };

  // Закрытие модального окна
  const closeModal = () => {
    setSelectedPdf(null);
    setSelectedFileType(null);
  };

  useEffect(() => {
  serverPdfUrls
    .filter(file => file.type.includes("image"))
    .forEach(file => loadImagePreview(file));
  }, [serverPdfUrls]);
 
  // Загружать PDF при старте страницы
  useEffect(() => {
    loadCablePdfFromServer(id, setServerPdfUrls, setUploadMessage);
  }, []); 

  const pdfFiles = serverPdfUrls.filter(file => file.type.includes("pdf"));
  const imageFiles = serverPdfUrls.filter(file => file.type.includes("image"));

  const availableTabs = [
    ...(pdfFiles.length > 0 ? [{ label: 'PDF', contentType: 'pdf' }] : []),
    ...(imageFiles.length > 0 ? [{ label: 'PHOTO', contentType: 'image' }] : [])
  ];

// Обеспечиваем, что индекс в пределах доступных вкладок
useEffect(() => {
  if (tabIndex >= availableTabs.length) {
    setTabIndex(0);
  }
}, [availableTabs.length]);

     return (
    <Dialog open={open} className="modalStyleFoto" fullWidth maxWidth="md">
      <DialogContent>
        <div className='divFotoRes' style={{ width: '100%', height: '100%', paddingRight: '10px' }}>
          <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>Файлы кабеля</label>
          
          <label style={{ color: '#292929', fontWeight: 'bold' , marginLeft: '5px'}}>
            ID: <span style={{ color: '#bebebe', fontWeight: 'normal' }}>{id}</span>
          </label>
          

        <Tabs
          value={tabIndex}
          onChange={(e, newIndex) => setTabIndex(newIndex)}
          TabIndicatorProps={{ style: { backgroundColor: '#dfab01' } }}
          textColor="inherit"
          sx={{
            '& .MuiTab-root': { color: '#dfab01' },
            '& .Mui-selected': { color: '#dfab01' }
          }}
        >
          {availableTabs.map((tab, idx) => (
            <Tab key={idx} label={tab.label} />
          ))}
      </Tabs>

      {/* Контент вкладок */}
{availableTabs[tabIndex]?.contentType === 'pdf' && (
  <Box>
    {pdfFiles.map((pdf, index) => (
      <div key={index} style={{ marginTop: '10px', maxWidth: '100%' }}>
        {/* Кнопка PDF */}
        <button
          style={{
            cursor: 'pointer',
            display: 'block',
            width: '100%',
            borderRadius: '10px',
            margin: '0 auto',
            padding: '10px',
            background: 'linear-gradient(45deg, #f0d47f,#f5cb4e)',
            transition: 'background 0.3s ease',
            overflow: 'hidden',
          }}
          onClick={() => handlePdfClick(pdf.url, pdf.type)}
          onMouseOver={(e) => e.currentTarget.style.background = 'linear-gradient(45deg, #d2f7a3, #abe861)'}
          onMouseOut={(e) => e.currentTarget.style.background = 'linear-gradient(45deg, #f0d47f, #f5cb4e)'}
        >
          <span style={{ color: '#666665', fontWeight: 'bold' }}>
            Открыть {pdf.fileName.split('.').pop().toUpperCase()}:
          </span>
         <button
        style={{
          padding: '2px',
          backgroundColor: 'transparent',
          color: '#28a745',
          marginLeft: "10px",
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          border: 'none'
        }}
        onClick={async (e) => {
          e.stopPropagation(); // чтобы не открывалось модальное
          try {
            const token = localStorage.getItem("token");
            const response = await fetch(pdf.url, {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (!response.ok) throw new Error("Ошибка скачивания файла");

            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = pdf.fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(objectUrl);
          } catch (err) {
            console.error(err);
          }
        }}
      >
        <GetAppIcon style={{ fontSize: '24px' }} />
      </button>
          <hr className='horizontalLineDialog' />
          {pdf.fileName}
        </button>
      </div>
    ))}
  </Box>
)}

{availableTabs[tabIndex]?.contentType === 'image' && (
  <Box>
    <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '15px',
      marginTop: '15px'
    }}>
      {imageFiles.map((img, index) => (
        <div key={index} style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => handlePdfClick(img.url, img.type)}>
          <img
             src={imagePreviews[img.url] || ""}
            alt={img.fileName}
            style={{
              width: '100%',
              maxHeight: '200px',
              objectFit: 'cover',
              borderRadius: '10px',
              border: '1px solid #e2a703',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.6)', // 👈 Чёрная тень
              transition: '0.3s'
            }}
          />
         
        </div>
      ))}
    </div>
  </Box>
)}

          {uploadMessage && <p>{uploadMessage}</p>}

          {/* Модальное окно просмотра PDF или изображения */}
          {selectedPdf && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
              }}
              onClick={closeModal}
            >
              {selectedFileType === 'pdf' ? (
                <embed src={selectedPdf} type="application/pdf" width="90%" height="90%" style={{ backgroundColor: '#fff' }} />
              ) : (
                <div style={{ width: '70%', height: '90%', overflow: 'auto', backgroundColor: '#fff' }}>
                  <img
                    src={selectedPdf}
                    alt="Просмотр файла"
                    style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: 'none' }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogCablePdf;

//     return (
//       <Dialog open={open} className="modalStyleFoto" fullWidth maxWidth="md"> 
//       <DialogContent>
//         <div className='divFotoRes' style={{ width: '100%', height: '100%', paddingRight: '10px' }}>
//         <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Файлы кабеля</label>
//               <br/>
//               <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',fontWeight: 'normal' }}>{id}</span> </label>
//               <hr className='horizontalLineDialog'/>
//         {serverPdfUrls.length > 0 && (
//     <div style={{ overflow: 'hidden' }}>
//     {serverPdfUrls.map((pdf, index) => (
//       <div key={index} style={{ marginTop: '10px', maxWidth: '100%', overflow: 'hidden' }}>
//        <button
//           style={{
//             cursor: 'pointer',
//             display: 'block',
//             width: '100%',
//             borderRadius: '10px',
//             maxWidth: 'calc(100% - 20px)', 
//             margin: '0 auto', 
//             padding: '10px', 
//             boxSizing: 'border-box',
//             textOverflow: 'ellipsis', 
//             overflow: 'hidden', 
//             background: 'linear-gradient(45deg, #f0d47f,#f5cb4e )', 
//             transition: 'background 0.3s ease', 
//           }}
//           onClick={() => handlePdfClick(pdf.url, pdf.type)} 
//           onMouseOver={(e) => e.currentTarget.style.background = 'linear-gradient(45deg, #d2f7a3, #abe861)'} 
//           onMouseOut={(e) => e.currentTarget.style.background = 'linear-gradient(45deg, #f0d47f, #f5cb4e)'} 
//         >
//           <span style={{ color: '#666665', fontWeight: 'bold' }}>Открыть {pdf.fileName.split('.').pop().toUpperCase()}: </span>
//           <a
//             href={pdf.url}
//             download={pdf.fileName}
//             style={{
//               padding: '2px',
//               backgroundColor: 'transparent', 
//               color: '#28a745', 
//               borderRadius: '5px',
//               fontSize: '16px',
//               marginLeft: "10px",
//               cursor: 'pointer',
//               transition: 'background-color 0.3s ease', 
//               display: 'inline-flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}
//             onClick={(e) => e.stopPropagation()} 
//           >
//             <GetAppIcon style={{ color: '#28a745', fontSize: '24px' }} />
//           </a>

//           <hr className='horizontalLineDialog' />
//           {pdf.fileName}

//         </button>
        
//       </div>
//     ))}
//     </div>
//     )}
//     {uploadMessage && <p>{uploadMessage}</p>}

//     {/* Модальное окно для просмотра PDF */}
//     {selectedPdf && (
//       <div
//         style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           backgroundColor: 'rgba(0, 0, 0, 0.8)',
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           zIndex: 1000
//         }}
//         onClick={closeModal} 
//       >
//          {selectedFileType === 'pdf' ? (
//         <embed
//           src={selectedPdf}
//           type="application/pdf"
//           width="90%"
//           height="90%"
//           style={{ backgroundColor: '#fff' }}
//         />
   
//       ) : (
//         <div style={{ width: '70%', height: '90%', overflow: 'auto', backgroundColor: '#fff' }}>
//         <img
//         src={selectedPdf}
//         alt="Просмотр файла"
//         style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: 'none' }}
//       />
//       </div>
//       )}
//       </div>
//     )}
//     </div>
//       </DialogContent>

//       <DialogActions>
//         <Button onClick={onClose} class='buttonIsHideModal'>
//           Закрыть
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// export default DialogCablePdf;